import React from 'react';
import { CampaignStep } from 'types';
import { Basic, Creatives, Targeting, KPIs, GoogleAnalytics, Complete } from 'pages/steps';

export const getStepContent = <Step extends CampaignStep>(step: Step): React.ReactElement => {
  switch (step) {
    case CampaignStep.Basic:
      return <Basic />;
    case CampaignStep.Creatives:
      return <Creatives />;
    case CampaignStep.Targeting:
      return <Targeting />;
    case CampaignStep.KPI:
      return <KPIs />;
    case CampaignStep.GA:
      return <GoogleAnalytics />;
    case CampaignStep.Complete:
      return <Complete />;
    default:
      const _never: never = step;
      throw new TypeError(`Unexpected step "${step}"`);
  }
};
